export const getQuestionId = (question, parentID = null) =>
  0 < question.position
    ? `${(question.pre_type && 'pq') || 'q'}${question.visual_position}`
    : 'sn' != question.type && 0 < question.visual_position && null !== parentID
    ? `${parentID.toUpperCase()}_${question.visual_position}`
    : question.id

export const getQuestionIcon = question =>
  'mp' == question.type
    ? 'radios' == question.subType
      ? `${window.icon_question_types[question.type]}-rb`
      : `${window.icon_question_types[question.type]}-cb`
    : window.icon_question_types[question.type]

export const hasComments = items => {
  if (!Array.isArray(items)) return false
  return (
    0 < items.length &&
    items.some(
      item =>
        null !== item && (item.comments || (Object.hasOwn(item, 'answerVariants') && hasComments(item.answerVariants)))
    )
  )
}
